export const colors = {
  greenMain: '#427F80',
  primary: '#30676E',
  primaryLight10: '#71B2AE',
  primaryLight50: '#E0F8F0',
  primaryDark20: '#21515C',
  primaryDeepTeal30: '#99D7D8',
  primaryDeepTeal40: '#306D6E',
  primaryDeepTeal60: '#71B1B2',
  primaryDeepTeal70: '#215B5C',
  secondaryLight40: '#DDF3F5',
  white: '#ffffff',
  black: '#000000',
  darkNavy: '#223742',
  secondaryDarkNavy: '#5A7F8D',
  secondaryDarkNavyPlus10: ' #182B38',
  darkNavySecondary: '#8CB9C6',
  darkNavyTertiary: '#5A7B8D',
  neutrals50: '#807F7D',
  neutrals40: '#A1A09E',
  neutrals30: '#D2CEC4',
  neutrals20: '#EEEDE9',
  neutrals10: '#F8F8F8',
  highlightWatermelon: '#E75D54',
  highlightWatermelonDark: '#C63D40',
  higlightSunshineDark: '#D29930',
  dangerLight: '#FFE4E4',
  dangerDark: '#BC4D4D',
  danger: '#E75D54',
  darkGray: '#333333',
  transparent: '#ffffff29',
  disabledHover: 'rgba(0, 0, 0, 0.25)',
  inputs: 'rgb(210, 206, 196)',
  tertiary: '#83C8C0',
  tertiaryDark10: '#5FACAA',
  tertiaryLight10: '#A4DED2',
  tertiaryLight20: '#ADDDE1',
  tertiaryT900: '#196058',
  info: '#68AAE8',
  infoLight: '#E1EDF8',
  infoDark: '#30577A',
  warning: '#FC2C66D',
  warningLight: '#F8E6C3',
  warningDark: '#B5821C',
  success: '#51B587',
  templatePrimary: '#315161',
  highlightSunshine: '#F5BC43',
  highlightSunshine600: '#BC8715',
  eventInvoiceType: '#83C8C0',
  eventTaskType: '#F26D6D',
  semanticWarning: '#F2C66D',
  preview: {
    template1: {
      primary: '#2BABAE',
      secondary: '#315161',
      fontDefatult: '#315161',
    },
    template2: {
      primary: '#DCB560',
      fontDefatult: '#3D464F',
    },
    template3: {
      primary: '#494848',
      fontDefatult: '#494848',
    },
    template4: {
      primary: '#9661A8',
      secondary: '#454854',
      fontDefatult: '#454854',
    },
    template5: {
      fontDefatult: '#191919',
      primary: '#81AD9B',
      secondary: '#F68F77',
      textPrimary: '#303030',
    },
    template6: {
      fontDefatult: '#30302F',
      primary: '#30302F',
      secondary: '#F0F3F3',
    },
    contract1: {
      fontDefatult: '#333333',
    },
  },
  // Box Time Tracker
  box: {
    today: {
      borderColor: '#8CB9C6',
      backgroundColor: '#BEE5EC',
      backgroundColorSecondary: '#F2C66D',
    },
    month: {
      borderColor: '#EEEDE9',
      backgroundColor: '#F8F8F8',
    },
    year: {
      borderColor: '#BEE5EC',
      backgroundColor: '#DDF3F5',
    },
    week: {
      borderColor: '#8CB9C6',
      backgroundColor: '#BEE5EC',
      backgroundColorSecondary: '#F2C66D',
    },
    invoiced: {
      borderColor: '#BEE5EC',
      backgroundColor: '#DDF3F5',
    },
    paid: {
      borderColor: '#C3F2E6',
      backgroundColor: '#E0F8F0',
    },
    unpaid: {
      borderColor: '#EEEDE9',
      backgroundColor: '#F8F8F8',
    },
    overdue: {
      borderColor: '#EEEDE9',
      backgroundColor: '#F8F8F8',
    },
  },
  // Toast colors
  toast: {
    error: {
      backgroundColor: '#FFE4E4',
      borderColor: '#F26D6D',
      fontColor: '#BC4D4D',
    },
    success: {
      backgroundColor: '#D5EFE3',
      borderColor: '#51B587',
      fontColor: '#367859',
    },
    warning: {
      backgroundColor: '#F8E6C3',
      borderColor: '#F3C872',
      fontColor: '#B5821C',
    },
    info: {
      backgroundColor: '#E1EDF8',
      borderColor: '#68AAE8',
      fontColor: '#30577A',
    },
  },
  tooltip: {
    dark: 'rgba(34, 55, 66, 0.9)',
  },
  notifications: {
    danger: '#FFE4E4',
    warning: '#F8E6C3',
    info: '#E1EDF8',
  },
};

export const fontWeights = {
  normal: '400',
  medium: '500',
  bold: '700',
  black: '900',
};

export const theme = {
  colors,
  fontWeights,
};
